<div *ngIf="!interfaceService.isTelesellerDomain" [class.active]="_showSelect" class="select-mobile d-block d-lg-none">
  <ul>
    <li
      [class.active]="allService.serviceType == service.type"
      (click)="clickLogo(service.type)"
      *ngFor="let service of arServices; let i = index"
      class="outline-none"
    >
      <a class="" title="{{ service.name }}">
        <i-feather [name]="service.type | fixType"></i-feather>
        <span *ngIf="service.unreadCount" class="unreadCount">{{ service.unreadCount }}</span>
      </a>
    </li>
    <li class="outline-none">
      <a (click)="setService('all')"><img loading="lazy" src="/assets/images/logo.svg" alt=""/></a>
    </li>
  </ul>
</div>

<div *ngIf="!interfaceService.isTelesellerDomain" (click)="showSelect = !_showSelect" class="navbar-mobile d-block d-lg-none">
  <button class="btn btn-white">
    <i-feather *ngIf="allService.serviceType !== 'all'" [name]="allService.serviceType | fixType"></i-feather>
    <span *ngIf="allService.serviceType === 'all'" class="fadein">
      <i-feather
        *ngFor="let service of arServices; let i = index"
        [name]="service.type | fixType"
      ></i-feather>
    </span>
  </button>
</div>

<!-- Navbar -->
<div class="d-none d-lg-flex navigation navbar navbar-light justify-content-center py-md-3 py-lg-5 py-xl-5">
  <!-- Brand -->
  <a
    routerLink="/"
    (click)="setService('all')"
    class="d-none d-md-block mb-6"
    [class.pointer]="allService.serviceType !== 'all'"
  >
    <img
      loading="lazy"
      [class.effectPulse]="false && allService.serviceType === 'all'"
      [class.active]="allService.serviceType === 'all'"
      src="assets/images/logo.svg"
      class="logo-left shadow-lg mx-auto fill-primary"
      style="height: 50px"
    />
  </a>
  <!-- Menu -->
  <ul
    id="menu-social"
    class="nav navbar-nav flex-row flex-md-column flex-grow-1 justify-content-between justify-content-md-center py-0"
    role="tablist"
  >
    <li
      (click)="goToLeads()" [class.active]="page === 'leads'"
      class="nav-item outline-none ml-md-5 mt-md-3"
    >
      <a
        nz-tooltip="" nzTooltipPlacement="right"
        class="nav-link position-relative p-0" title="Поиск лидов">
        <i-feather name="leads"></i-feather>
        <!--<span *ngIf="service?.unreadCount" class="unreadCount">{{ service.unreadCount }}</span>-->

      </a>
    </li>
    <li
      (click)="setService(service.type)"
      [class.active]="allService.serviceType === service.type && page !== 'leads'"
      *ngFor="let service of arServices; let i = index"
      class="nav-item outline-none ml-md-5 mt-md-3"
    >
      <a
        nz-tooltip="" nzTooltipPlacement="right" [nzTooltipTitle]="titleTemplate"
      class="nav-link position-relative p-0" title="{{ service.name }}">
      <i-feather [name]="service.type | fixType"></i-feather>
      <span *ngIf="service?.unreadCount" class="unreadCount">{{ service.unreadCount }}</span>
      <span *ngIf="service.nemuAccounts?.length > 1" class="unreadCount">{{service.nemuAccounts?.length }}</span>

      </a>
      <ng-template #titleTemplate>
        <ul nz-menu class="tooltip-menu">

          <li (click)="setService(subService.type)" *ngFor="let subService of service.nemuAccounts; let i = index"
              nz-menu-item class="d-flex align-items-center">
            <app-avatar
              [Service]="subService"
              [id]="subService.arProfile?.id"
              [type]="'private'"
              [avatar]="subService.arProfile?.avatar"
              [avatarFileId]="subService.arProfile?.avatar_file_id"
              [avatarFileUniqueId]="subService.arProfile?.avatar_file_unique_id"
              [serviceType]="subService.type"
              class="d-inline-block avatar avatar-sm mr-3"
            >
              <span
                class="chat-service-type avatar-type">
                <img
                  loading="lazy"
                  class="title-type"
                  width="30"
                  height="30"
                  title="Номер аккаунта"
                  src="/assets/icons/socials/{{ subService.type | fixType }}-empty.svg"
                  alt=""/>
                <i>{{ subService.type | serviceNumber }}</i>
              </span>
            </app-avatar>
            &nbsp;{{ subService.arProfile?.name?.first || subService.type}} {{ subService.arProfile?.name?.last }}

          </li>
          <li (click)="interfaceService.addAccount(service)" nz-menu-item>
            Добавить
          </li>
        </ul>
      </ng-template>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>

          <li (click)="setService(subService.type)" *ngFor="let subService of service.nemuAccounts; let i = index"
              nz-menu-item>
            {{ subService.arProfile?.name?.first || subService.type}} {{ subService.arProfile?.name?.last }}
          </li>
        </ul>
      </nz-dropdown-menu>
    </li>
  </ul>
  <ul
    *ngIf="isDebug"
    class="nav navbar-nav d-none d-md-block flex-row flex-md-column flex-grow-1 justify-content-between justify-content-md-center py-3 py-md-0"
    role="tablist"
  >
    <li routerLinkActive="active" routerLink="/settings" class="nav-item outline-none menu-settings pointer-event">
      <button
        *ngIf="!environment.production"
        nz-button
        nz-dropdown
        [nzDropdownMenu]="menu"
        [nzPlacement]="'bottomRight'"
        class="nav-link btn btn-sm position-relative p-0"
        tooltip="Настройки"
      >
        <i-feather name="settings" class="icon-lg"></i-feather>
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li *ngFor="let item of allService.arDetectChangesLog | keyvalue; let i = index" nz-menu-item>
            {{ item.key }} - {{ item.value }}
          </li>
          <li (click)="allService.openDevTools()" nz-menu-item>openDevTools</li>
        </ul>
      </nz-dropdown-menu>
    </li>
  </ul>
  <!-- Menu -->
</div>
<!-- Navbar -->
